import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function About() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => setS({}));
  }, []);
  if (!s) return <div className="p-16 text-center text-zinc-500">Loading…</div>;
  const paragraphs = (s.about_us_body || "").split(/\n\s*\n/).filter(Boolean);

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-20">
      <div className="text-label text-zinc-500">Our Story</div>
      <h1 className="font-display text-5xl sm:text-7xl mt-2" data-testid="about-title">{s.about_us_title || "About Card Lobster"}</h1>
      <div className="mt-8 space-y-6 text-zinc-300 leading-relaxed" data-testid="about-body">
        {paragraphs.length === 0
          ? <p>{s.about_us_body}</p>
          : paragraphs.map((p, i) => <p key={i}>{p}</p>)}
      </div>
      {s.contact_email && (
        <div className="mt-12 border-t border-white/10 pt-8">
          <div className="text-label text-zinc-500">Get in touch</div>
          <a href={`mailto:${s.contact_email}`} className="font-display text-2xl mt-2 inline-block text-[var(--cl-orange)] hover:underline" data-testid="about-email">
            {s.contact_email}
          </a>
        </div>
      )}
    </div>
  );
}
